import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/core/styles';
import { Paper, FormControl, TextField, InputAdornment, InputLabel, MenuItem, Select, LinearProgress } from '@material-ui/core';
import VariantSnackbar from '../share/VariantSnackbar';
import FilterBeneficiario from '../share/FilterBeneficiario';
import Utils from '../share/Utils';
import IntegrationAutosuggest from '../share/IntegrationAutosuggest';
import ProcessoService from '../../services/ProcessoService';
import { parse, format } from 'date-fns';

const styles = theme => ({
  paper: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit,
    paddingBottom: theme.spacing.unit,
    marginTop: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit * 2,
  },
  body: {
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit,
  },
  formControlAutoCompleteBenef: {
    margin: theme.spacing.unit,
    minWidth: 400,
  },
  formControlValor: {
    margin: theme.spacing.unit,
    marginLeft: theme.spacing.unit * 3,
    width: 200,
  },
  textFieldDtaEfeitoFinac: {
    marginBottom: theme.spacing.unit,
    marginLeft: theme.spacing.unit,
    width: 232,
    marginRight: theme.spacing.unit * 2,
  },
  selectAnoProcesso: {
    width: 180,
    marginTop: theme.spacing.unit * 0.5,
    marginBottom: theme.spacing.unit * 0.5,
  },
  textFieldNumProcesso: {
    width: 180,
    marginLeft: theme.spacing.unit,
    margin: theme.spacing.unit * -1.5,
  },
  selectOrigem: {
    margin: theme.spacing.unit,
    marginLeft: theme.spacing.unit * 3,
    width: 830,
  },
  formControlObservacao: {
    margin: theme.spacing.unit,
    marginLeft: theme.spacing.unit * 3,
    width: 830,
  },
  formControlValorInfo: {
    margin: theme.spacing.unit,
    marginLeft: theme.spacing.unit * 3,
    width: 255,
  },
});
class FormDialogAcertoMensalidade extends React.Component {
  utils = new Utils();
  processoService = new ProcessoService();
  constructor (props) {
    super(props);
    this.state = {
      ...this.props.acerto,
      fetching: false,
      fetchingProcessos: false,
      nomesBeneficiarios: this.props.nomesBeneficiarios,
      processos: [],
      snackOpen: false,
      snackMessage: '',
      sucesso: false,
      errorMessageValor: '',
      errorMessageData: '',
    };
    this.state.valAcerto = this.state.valAcerto === undefined ? '' : this.state.valAcerto;
    this.state.valPago = this.state.valPago === undefined ? '' : this.state.valPago;
    this.state.valCorreto = this.state.valCorreto === undefined ? '' : this.state.valCorreto;
    this.state.valDiferenca = this.state.valDiferenca === undefined ? '' : this.state.valDiferenca;
    this.state.dtaEfeitoFinanc = format(parse(this.state.dtaEfeitoFinanc), 'YYYY-MM-DD');
  }

  handleCloseSnackbar = () => {
    this.setState({ snackOpen: false });
  };

  componentDidMount = async () => {
    if (this.props.acerto.anoProcesso !== undefined && this.props.acerto.anoProcesso !== null) {
      await this.consultarProcessos(this.props.acerto.anoProcesso);
    }
  }

  consultarProcessos = async (ano) => {
    let processos = await this.processoService.consultarProcessos(ano);
    this.setState({processos: processos});
  }

  handleClickLimpar = async () => {
    this.setState({
      numMatricula: '',
      nomeBeneficiario: ''
    });
  }

  handleSelectBeneficiario = (carteira, nome) => {
    this.setState({
      numMatricula: carteira,
      nomeBeneficiario: nome
    });
  }

  handleBlurValor = event => {
    if (this.state.valAcerto === '' || this.state.valAcerto === null || this.state.valAcerto === undefined) {
      this.setState({errorMessageValor: 'Favor preencher o valor'});
    }
  }

  handleBlurData = event => {
    if (this.state.dtaEfeitoFinanc === null ||
      this.state.dtaEfeitoFinanc === undefined ||
      this.state.dtaEfeitoFinanc === '') {
      this.setState({errorMessageData: 'Este campo é obrigatório'});
    } else {
      this.setState({errorMessageData: ''});
    }
  }

  handleChangeTextField = event => {
    var valorNovo = '';
    if (event.target.name === 'valAcerto') {
      valorNovo = event.target.value !== '' ? this.utils.formataValorNegativo(event.target.value, event.target.defaultValue) : '';
      this.setState({ [event.target.name]: valorNovo, errorMessageValor: '' });
    }
  };
  handleChange = event => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  }
  handleChangeSelectAnoProcesso = async event => {
    this.setState({fetchingProcessos: true, numProcesso: ''});
    if (event.target.value !== 0) {
      let processos = await this.processoService.consultarProcessos(event.target.value);
      this.setState({ processos: processos });
    } else {
      await this.processoService.consultarAnosProcessos();
    }
    this.setState({anoProcesso: event.target.value, fetchingProcessos: false});
  }
  getSuggestionValueNumProcesso = (suggestion, id, a) => {
    if (suggestion.nome !== undefined) {
      this.setState({numProcesso: Number(suggestion.nome)});
    }
    if (suggestion === '' && id === 0) {
      this.setState({numProcesso: undefined});
    }
    return suggestion.nome;
  }
  handleChangeObservacao = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  isSalvarDisabled = () => {
    return (this.state.errorMessageValor !== '' ||
    this.state.valAcerto === undefined ||
    this.state.valAcerto === 0 ||
    this.state.valAcerto === '') ||

    (this.state.errorMessageData !== '' ||
     this.state.dtaEfeitoFinanc === undefined ||
     this.state.dtaEfeitoFinanc === 'Invalid Date' ||
     this.state.dtaEfeitoFinanc === '') ||

    (this.state.nomeBeneficiario === '' ||
     this.state.nomeBeneficiario === undefined) ||

     (
       ((this.state.anoProcesso !== undefined && this.state.anoProcesso !== 0) && (this.state.numProcesso === undefined || this.state.numProcesso === '' || this.state.numProcesso === 0)) ||
       ((this.state.anoProcesso === undefined || this.state.anoProcesso === 0 || this.state.anoProcesso === '') && (this.state.numProcesso !== undefined && this.state.numProcesso !== '' && this.state.numProcesso !== 0))
     );
  }

  handleClickSave = async () => {
    const acerto = {
      numProtocolo: this.state.numProtocolo === undefined ? 0 : this.state.numProtocolo,
      seqBeneficiario: this.state.seqBeneficiario === undefined ? 0 : this.state.seqBeneficiario,
      seqDependente: this.state.seqDependente === undefined ? 0 : this.state.seqDependente,
      numMatricula: this.state.numMatricula,
      nomeBeneficiario: '',
      valAcerto: this.state.valAcerto.replace('.', '').replace(',', '.'),
      codOrigem: this.state.codOrigem === undefined ? 2 : this.state.codOrigem,
      desOrigem: '',
      codEstado: this.state.codEstado === undefined ? 0 : this.state.codEstado,
      desEstado: '',
      txtObservacao: this.state.txtObservacao === undefined ? '' : this.state.txtObservacao,
      dtaCadastro: null,
      dtaEfeitoFinanc: this.state.dtaEfeitoFinanc === undefined ? null : this.state.dtaEfeitoFinanc,
      numProcesso: this.state.numProcesso === undefined ? 0 : this.state.numProcesso,
      anoProcesso: this.state.anoProcesso === undefined ? 0 : this.state.anoProcesso,
      valPago: 0,
      valCorreto: 0,
      historicos: [],
    };
    await this.props.handleSave(acerto);
  }
  render () {
    const { classes, open, handleClose, titulo } = this.props;
    return (
      <div>
        <Dialog
          disableBackdropClick
          maxWidth='md'
          fullWidth
          open={open}
          onClose={handleClose}
        >
          <DialogTitle>
            {titulo}
          </DialogTitle>
          <DialogContent>
            <Paper className={classes.body} elevation={1}>
              <FormControl component='filedset' className={classes.formControlAutoCompleteBenef}>
                <FilterBeneficiario
                  beneficiarios={this.props.nomesBeneficiarios}
                  disabled={!this.props.isEditavel}
                  nomeInicial={this.state.nomeBeneficiario}
                  carteiraInicial={this.state.numMatricula}
                  handleSelectBeneficiario={this.handleSelectBeneficiario}
                  handleClickLimpar={this.handleClickLimpar} />
              </FormControl>
              <FormControl className={classes.formControlValor}>
                <TextField
                  value={this.state.valAcerto === null ? '0,00' : this.utils.formataValorNegativo(this.state.valAcerto)}
                  disabled={!this.props.isEditavel}
                  margin='dense'
                  id='valAcerto'
                  name='valAcerto'
                  error={this.state.errorMessageValor !== ''}
                  label={this.state.errorMessageValor !== '' ? this.state.errorMessageValor : 'Valor'}
                  fullWidth
                  onChange={this.handleChangeTextField}
                  onBlur={this.handleBlurValor}
                  InputProps={{
                    startAdornment: <InputAdornment position='start'>R$</InputAdornment>
                  }}
                />
              </FormControl>
              <FormControl>
                <TextField
                  id='date'
                  disabled={!this.props.isEditavel}
                  error={this.state.errorMessageData !== ''}
                  label={this.state.errorMessageData !== '' ? this.state.errorMessageData : 'Data Efeito Finac.'}
                  type='date'
                  value={this.state.dtaEfeitoFinanc}
                  onChange={this.handleChange}
                  onBlur={this.handleBlurData}
                  inputProps={{
                    name: 'dtaEfeitoFinanc',
                  }}
                  className={classes.textFieldDtaEfeitoFinac}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </FormControl>
              <FormControl>
                <InputLabel shrink htmlFor='tipo-simple' className={classes.selectAnoProcesso}>
                  Ano Processo
                </InputLabel>
                <Select
                  className={classes.selectAnoProcesso}
                  disabled={!this.props.isEditavel}
                  value={this.state.anoProcesso}
                  onChange={this.handleChangeSelectAnoProcesso}
                  inputProps={{
                    name: 'anoProcesso',
                  }}
                >
                  <MenuItem key={0} value={0}>{''}</MenuItem>
                  {this.props.anosProcessos.map((ano, idx) => {
                    return (<MenuItem key={idx + 1} value={ano}>{ano}</MenuItem>);
                  })}
                </Select>
              </FormControl>
              <FormControl className={classes.textFieldNumProcesso}>
                {this.state.fetchingProcessos ? <LinearProgress color='primary' />
                  : <IntegrationAutosuggest
                    disabled={this.state.anoProcesso === null || this.state.anoProcesso === undefined || this.state.anoProcesso === 0 || !this.props.isEditavel}
                    getSuggestionValue={this.getSuggestionValueNumProcesso}
                    suggestions={this.state.processos}
                    idSelected={this.state.anoProcesso === null || this.state.anoProcesso === undefined ? 0 : this.state.anoProcesso}
                    nomeSelected={this.state.numProcesso === null || this.state.numProcesso === undefined || this.state.numProcesso === 0 ? '' : this.state.numProcesso.toString()}
                    maxSuggestions={3}
                    label={'Número Processo'} />}
              </FormControl>
              <FormControl>
                <InputLabel shrink htmlFor='tipo-simple' className={classes.selectOrigem}>
                  Origem
                </InputLabel>
                <Select
                  disabled
                  className={classes.selectOrigem}
                  value={this.state.codOrigem === null || this.state.codOrigem === undefined ? 2 : this.state.codOrigem}
                  onChange={this.handleChange}
                  inputProps={{
                    name: 'codOrigem',
                  }}
                >
                  {this.props.origens.map((origem, idx) => {
                    return (<MenuItem key={idx} value={origem.id}>{origem.nome}</MenuItem>);
                  })}
                </Select>
              </FormControl>

              <FormControl className={classes.formControlObservacao}>
                <TextField
                  value={this.state.txtObservacao === null ? '' : this.state.txtObservacao}
                  margin='dense'
                  disabled={!this.props.isEditavel}
                  id='txtObservacao'
                  name='txtObservacao'
                  label='Observação'
                  fullWidth
                  onChange={this.handleChangeObservacao}
                  multiline
                  style={{maxlength: '1000'}}
                  rowsMax='10'
                  helperText='(max. 1.000 caracteres)'
                />
              </FormControl>
              <FormControl className={classes.formControlObservacao}>
                <TextField
                  value={this.state.desSituacao}
                  margin='dense'
                  disabled
                  id='desSituacao'
                  name='desSituacao'
                  label='Situação'
                  fullWidth
                />
              </FormControl>
            </Paper>
            { this.state.codOrigem !== 1 && this.state.codOrigem !== 2 && !this.props.modoInclusao && false
              ? <Paper>
                <FormControl className={classes.formControlValorInfo}>
                  <TextField
                    value={this.state.valCorreto === null ? '' : this.utils.formataValorNegativo(this.state.valCorreto)}
                    disabled
                    margin='dense'
                    label={'Valor Correto que Deveria ser pago'}
                    fullWidth
                    InputProps={{
                      startAdornment: <InputAdornment position='start'>R$</InputAdornment>
                    }}
                  />
                </FormControl>
                <FormControl className={classes.formControlValorInfo}>
                  <TextField
                    value={this.state.valPago === null ? '' : this.utils.formataValorNegativo(this.state.valPago)}
                    disabled
                    margin='dense'
                    label={'Valor Pago Mensalidade'}
                    fullWidth
                    InputProps={{
                      startAdornment: <InputAdornment position='start'>R$</InputAdornment>
                    }}
                  />
                </FormControl>
                <FormControl className={classes.formControlValorInfo}>
                  <TextField
                    value={this.state.valDiferenca === null || this.state.valDiferenca === '' ? '' : this.utils.formataValorNegativo(this.state.valDiferenca)}
                    disabled
                    margin='dense'
                    label={'Diferença'}
                    fullWidth
                    InputProps={{
                      startAdornment: <InputAdornment position='start'>R$</InputAdornment>
                    }}
                  />
                </FormControl>
              </Paper>
              : null}
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color='primary' id={'fechar'}>
              Fechar
            </Button>
            <Button
              disabled={this.isSalvarDisabled() || !this.props.isEditavel}
              onClick={this.handleClickSave}
              color='primary'>
              Salvar
            </Button>
          </DialogActions>
        </Dialog>
        <VariantSnackbar
          vertical={'top'}
          horizontal={'right'}
          variant={this.state.sucesso ? 'success' : 'error'}
          message={this.state.snackMessage}
          open={this.state.snackOpen}
          handleClose={this.handleCloseSnackbar} />
      </div>
    );
  }
}
export default withStyles(styles)(FormDialogAcertoMensalidade);
